<template>
  <div
    class="feedback-button text-white w-11 h-28 rounded-md u-center cursor-pointer bg-red-500 hover:bg-red-600 overflow-hidden"
    :aria-label="$t('main.feedback')"
    @click="openFeedbackModal"
  >
    <div class="text-base whitespace-nowrap transform -rotate-90">{{ $t('main.feedback') }}</div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useModal } from '~/composables/useModal';

export default defineComponent({
  components: {},
  setup() {
    const { openModal } = useModal();
    const openFeedbackModal = () => {
      openModal(import('~/modules/common/components/modals/ModalFeedback' /* webpackChunkName: "ModalFeedback" */));
    };
    return { openFeedbackModal };
  },
});
</script>
